import { render, staticRenderFns } from "./ControleAcesso.vue?vue&type=template&id=5099f86c"
import script from "./ControleAcesso.vue?vue&type=script&lang=js"
export * from "./ControleAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports